import { Drawer, Grid, IconButton, MenuItem, Menu } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import SlideButton from "../../../assets/icons/bars.svg";
import SlideButtonOrange from "../../../assets/icons/barsOrange.svg";
import NotificationIcon from "../../../assets/icons/notification.svg";
import AccountIcon from "../../../assets/icons/user2.svg";
import AccountIconNew from "../../../assets/icons/user_managemnt_black.svg";
import companyNameIcon from "../../../assets/icons/office_building.svg";
import MailIcon from "../../../assets/icons/mail.svg";
import ROleIcon from "../../../assets/icons/security.svg";
import { getBrandName } from "../../../constants/mapping";
import { logOut } from "../../../modules/actions/login.action";
import { requestMe, resetMe } from "../../../modules/actions/me.action";
import {
  objectHasKeysCheck,
  userIsProductPartner,
} from "../../../services/commonMethods";
import { collapseSidebar } from "../../../modules/actions/collapseSidebar.action";
import { Fragment } from "react";
import ReactWebSocket from "../ReactWebSocket";
import { ENUMS, ENV_CONFIG, NOTIFICATION_TYPES_KEY } from "../../../constants";
import RealTimeNotifications from "../RealTimeNotification";
import ReactNotification from "react-notifications-component";
import NotificationContainer from "../../components/NotificationContainer";
import { requestNotifications } from "../../../modules/actions/notifications.action";
import { DESC } from "../../../constants";
import NotificationActiveIcon from "../../../assets/icons/notification_orange.svg";
import { BootstrapTooltip } from "../ActionColumn";
import { ReactComponent as FeedbackModalIcon } from "../../../assets/icons/Feedback_Icon.svg";
import {
  triggerFeedbackModal,
  triggerConfigAppPasswordModal,
} from "../../../modules/actions/modals.action";
import { requestRefillList } from "../../../modules/actions/refillList.action";
import { requestVMList } from "../../../modules/actions/vmList.action";
import { initializePayloadMethod } from "../../../services/apiRequestMethods";

function TopNavbar(props) {
  const notifications = useSelector((state) => state.notificationsReducer.list);
  const collapseSidebarBool = useSelector(
    (state) => state.collapseSidebarReducer.collapseSidebar
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notifyObj, setNotifyObj] = useState({});
  const [anchorElNotification, setAnchorElNotification] = React.useState(null);
  const dispatchActions = useDispatch();

  const notificationIsAllowed =
    props.me.Role && !userIsProductPartner.call({ props });

  //Show feedback modal
  const handleFeedbackModal = () => {
    dispatchActions(triggerFeedbackModal());
  };
  //Show config app password modal
  const handleConfigAppPasswordModal = () => {
    dispatchActions(triggerConfigAppPasswordModal());
  };
  const me = useSelector((state) => state.meReducer.data);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickNotification = (event) => {
    setAnchorElNotification(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseNotification = () => {
    setAnchorElNotification(null);
  };

  useEffect(() => {
    dispatchActions(
      requestMe("/user-management", {
        payload: {
          action: "me",
        },
      })
    );
  }, []);

  useEffect(() => {
    if (notificationIsAllowed) {
      dispatchActions(
        requestNotifications("/notification-service", {
          payload: {
            action: "list.notifications",
            sortBy: "created_at",
            sortDir: DESC.toUpperCase(),
            limit: 10,
            offset: 0,
          },
        })
      );
    }
  }, [props.me]);
  const onMessageReceived = (result) => {
    try {
      let data = JSON.parse(result);
      setNotifyObj(data);

      //If real time notification and user is on refill list page, refresh the list
      if (
        props.history.location.pathname === "/refills" &&
        data.type === NOTIFICATION_TYPES_KEY.REFILL_EXECUTE
      ) {
        props.requestRefillList(
          "/refill-management",
          initializePayloadMethod(
            "list.refills",
            { vending_machine_id: props.refillListPayload.vending_machine_id },
            props.refillListPayload
          )
        );
      }
      //If real time notification and user is on VM list page, refresh the list
      if (
        props.history.location.pathname === "/vm" &&
        data.type === NOTIFICATION_TYPES_KEY.VM_STATUS
      ) {
        props.requestVMList(
          "/vending-machine-management",
          initializePayloadMethod(
            "list.active_vending_machines",
            {},
            props.vmListPayload
          )
        );
      }
      dispatchActions(
        requestNotifications("/notification-service", {
          payload: {
            action: "list.notifications",
            sortBy: "created_at",
            sortDir: DESC.toUpperCase(),
            limit: 10,
            offset: 0,
          },
        })
      );
    } catch (err) {
      console.log("err in receiving msg", err);
    }
  };

  return (
    <Fragment>
      {notificationIsAllowed && (
        <ReactWebSocket
          url={ENV_CONFIG.notificationWebSocketUrl}
          onMessage={onMessageReceived}
        />
      )}
      <ReactNotification />
      {notifyObj && objectHasKeysCheck(notifyObj) ? (
        <RealTimeNotifications
          data={notifyObj}
          onRemoval={() => setNotifyObj({})}
        />
      ) : (
        ""
      )}
      <Drawer
        variant="permanent"
        open={true}
        anchor="top"
        classes={{
          paperAnchorTop: `${
            collapseSidebarBool ? "top-navbar-collapse" : "top-navbar"
          }`,
        }}
      >
        <Grid container>
          <Grid item lg={1} md={1} sm={1} className="text-center">
            <IconButton
              aria-label="slide"
              classes={{
                root: "slide-btn",
              }}
              onClick={() => dispatchActions(collapseSidebar())}
            >
              <img
                src={collapseSidebarBool ? SlideButtonOrange : SlideButton}
                alt="slide-btn"
              />
            </IconButton>
          </Grid>
          <Grid item lg={5} md={4} sm={3} className="text-left">
            <h3 className="brand-navbar">
              {getBrandName(props.location.pathname)}
            </h3>
          </Grid>
          <Grid item lg={6} md={7} sm={8} className="text-right">
            {notificationIsAllowed && (
              <span>
                <BootstrapTooltip
                  title="Notifications"
                  placement="bottom"
                  onClick={() => props.history.push("/notifications")}
                >
                  <IconButton
                    aria-label="slide"
                    classes={{ root: "slide-btn" }}
                    onClick={handleClickNotification}
                  >
                    <img
                      src={
                        Boolean(anchorElNotification) ||
                        props.location.pathname === "/notifications"
                          ? NotificationActiveIcon
                          : NotificationIcon
                      }
                      alt="slide-btn"
                    />
                  </IconButton>
                </BootstrapTooltip>
                <Menu
                  id="simple-menu-notification"
                  anchorEl={anchorElNotification}
                  keepMounted
                  open={Boolean(anchorElNotification)}
                  onClose={handleCloseNotification}
                  className="menu-item"
                >
                  <h4 className="notification-title">Notifications</h4>
                  {notifications.slice(0, 5).map((notification) => {
                    return (
                      <MenuItem key={notification.id}>
                        <NotificationContainer data={notification} />
                      </MenuItem>
                    );
                  })}
                  {notifications.length === 0 ? (
                    <p
                      style={{
                        padding: "20px",
                        fontWeight: "500",
                        marginBottom: "0",
                        fontSize: "13px",
                      }}
                    >
                      No Notifications Available
                    </p>
                  ) : (
                    ""
                  )}

                  <p
                    className="view-all-button"
                    onClick={() => {
                      handleCloseNotification();
                      props.history.push("/notifications");
                    }}
                  >
                    View all Notifications
                  </p>
                </Menu>
              </span>
            )}
            {objectHasKeysCheck(me) ? (
              <IconButton
                aria-label="slide"
                classes={{ root: "slide-btn2 btn-dropdown" }}
                onClick={handleClick}
                style={{ textTransform: "capitalize" }}
              >
                <img src={AccountIcon} alt="slide-btn" />{" "}
                {objectHasKeysCheck(me)
                  ? `${me.first_name.substr(0, 11)} ${me.last_name.substr(
                      0,
                      6
                    )} ${me.last_name.length > 6 ? ".." : ""}`
                  : ""}
              </IconButton>
            ) : (
              ""
            )}
            <Menu
              id="simple-menu-notification"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              className="menu-item menu-item-profile"
            >
              <p className="profile-title">My Profile</p>
              <MenuItem>
                <img src={companyNameIcon} alt="slide-btn" />{" "}
                <span className="ellipsis user-profile-card__company-name ">
                  {me.Company ? me.Company.name : ""}
                </span>
              </MenuItem>
              <MenuItem>
                <img src={AccountIconNew} alt="slide-btn" /> {me.first_name}{" "}
                {me.last_name}
              </MenuItem>
              <MenuItem>
                <span style={{ textTransform: "lowercase" }}>
                  <img src={MailIcon} alt="slide-btn" /> {me.email}
                </span>
              </MenuItem>
              <MenuItem>
                <img src={ROleIcon} alt="slide-btn" />{" "}
                {me.Role ? me.Role.name : ""}
              </MenuItem>
              <MenuItem
                className="logout-user"
                onClick={() => {
                  dispatchActions(resetMe());
                  dispatchActions(logOut());
                }}
              >
                <span />
                Logout
              </MenuItem>
              {me.Company &&
                me.Company.type === ENUMS.COMPANY_TYPE.WITHOUT_FRANCHISE && (
                  <MenuItem
                    onClick={handleConfigAppPasswordModal}
                    className="config-app__container"
                  >
                    <button className="config-app__guest-password">
                      Get Config App Login Details
                    </button>
                  </MenuItem>
                )}
            </Menu>
            <BootstrapTooltip
              title="Give Feedback/Report an Issue"
              placement="bottom"
            >
              <IconButton
                aria-label="slide"
                classes={{ root: "slide-btn" }}
                onClick={handleFeedbackModal}
              >
                <i className="feedback-form__icon">
                  <FeedbackModalIcon />
                </i>
              </IconButton>
            </BootstrapTooltip>
          </Grid>
        </Grid>
      </Drawer>
    </Fragment>
  );
}
{
}

const mapStateToProps = (state) => ({
  refillListPayload: state.refillListReducer.payload,
  vmListPayload: state.vmListReducer.others,
  me: state.meReducer.data,
});

const mapDispatchToProps = (dispatch) => ({
  requestRefillList: (urlEndPoint, payload) =>
    dispatch(requestRefillList(urlEndPoint, payload)),
  requestVMList: (urlEndPoint, payload) =>
    dispatch(requestVMList(urlEndPoint, payload)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TopNavbar)
);
